import timg1 from '../images/team/founder.png'
import timg2 from '../images/team/co-founder.png'
import timg3 from '../images/team/agent-2.png'







const Teams = [
  {
    id: "1",
    title: "Anand Kaila",
    subtitle: "Founder",
    slug: "anand-kaila",
    timg: timg1,   // images/founder.png
  },
  {
    id: "2",
    title: "Dhaval Gauswami",
    subtitle: "Co-Founder",
    slug: "dhaval-gauswami",
    timg: timg2,   // images/co-founder.png
  },
  {
    id: "3",
    title: "Devansh Jogel",
    subtitle: "Agent",
    slug: "devansh-jogel",
    timg: timg3,   // images/agent-2.png
  },
 
];


export default Teams;



